import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import ReactDOM from 'react-dom';
import { PORTAL_INLET_ATTR } from "../RenderContainer";

// Заглушка нужна для корректной гидрации порталов после SSR,
// которую реакт сам пока не поддерживает.
// @see https://github.com/facebook/react/issues/13097
// А также для вставки актуального render-container-id на клиенте.
//
// Дело в том, что во время гидрации, структура HTML на сервере
// и на клиенте должна совпадать, иначе возможны артефакты.
// Алгоритм там примерно такой. Клиент во время гидрации идет
// по этим двум деревьям и сравнивает узлы. Элементы разных типов
// он подменяет на свои. А те, что совпадают, он оставляет как есть
// вместе со всеми атрибутами, навесив только обработчики событий.
//
// Поэтому, для портала, который рендерится только на клиенте,
// нужно использовать серверную заглушку, чтобы при гидрации
// он не испортил какой-то другой элемент. Null не подходит,
// т.к. на сервере он тоже не рендерится.
// А элемент с render-container-id нужно отрендерить с нуля.

var SSRPlaceholder = function SSRPlaceholder() {
  return /*#__PURE__*/React.createElement("script", {
    "data-id": "ssr-placeholder"
  });
};
export var Portal = function Portal(_ref) {
  var _ref2;
  var container = _ref.container,
    rt_rootID = _ref.rt_rootID,
    children = _ref.children;
  // container exists only in browser
  return /*#__PURE__*/(
    React.createElement(React.Fragment, null, container ? /*#__PURE__*/ReactDOM.createPortal(children, container) : /*#__PURE__*/React.createElement(SSRPlaceholder, null), container ? /*#__PURE__*/React.createElement("noscript", (_ref2 = {}, _ref2[PORTAL_INLET_ATTR] = rt_rootID, _ref2)) : /*#__PURE__*/React.createElement(SSRPlaceholder, null))
  );
};
export var RenderInnerContainer = /*#__PURE__*/function (_React$Component) {
  function RenderInnerContainer() {
    return _React$Component.apply(this, arguments) || this;
  }
  _inheritsLoose(RenderInnerContainer, _React$Component);
  var _proto = RenderInnerContainer.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      anchor = _this$props.anchor,
      children = _this$props.children,
      domContainer = _this$props.domContainer,
      rootId = _this$props.rootId;
    var inner = anchor;
    if (children) {
      inner = /*#__PURE__*/
      React.createElement(React.Fragment, null, anchor, /*#__PURE__*/
      React.createElement(Portal, {
        key: "portal-ref",
        rt_rootID: rootId,
        container: domContainer
      }, children));
    }
    return inner;
  };
  return RenderInnerContainer;
}(React.Component);
RenderInnerContainer.__KONTUR_REACT_UI__ = 'RenderInnerContainer';
RenderInnerContainer.displayName = 'RenderInnerContainer';
Portal.__KONTUR_REACT_UI__ = 'Portal';
Portal.displayName = 'Portal';